import { useTranslation } from "react-i18next";
import { ArrowLeft, Pencil, Warehouse } from "lucide-react";
import { Button } from "components/common/Button";
import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import type { RoomHeaderProps } from "./types";

export const RoomHeader = ({
  roomName,
  elementCount,
  onBack,
  onEdit,
}: RoomHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 mb-3 px-2 py-1.5 rounded-lg border border-blue-200 bg-blue-50">
      <Button
        variant="primary"
        size="sm"
        onClick={onBack}
        startAdornment={<ArrowLeft className="w-4 h-4" />}
        aria-label={t("smartSurveyor.rooms.backToRooms")}
      />
      <Warehouse className="w-4 h-4 shrink-0 text-blue-600" />
      <TruncatedTextTooltip
        text={roomName}
        className="flex-1 min-w-0 text-base font-bold text-blue-800"
      />
      <span className="shrink-0 text-sm font-medium text-blue-700">
        {t("smartSurveyor.reviewPage.elementsCount", { count: elementCount })}
      </span>
      {onEdit && (
        <Button
          variant="text"
          size="sm"
          aria-label={t("smartSurveyor.rooms.editRoom")}
          title={t("smartSurveyor.rooms.editRoom")}
          onClick={onEdit}
          className="!px-2 !text-blue-600 hover:!text-blue-800"
        >
          <Pencil size={16} />
        </Button>
      )}
    </div>
  );
};
